import { render, staticRenderFns } from "./ProductContentAssignments.vue?vue&type=template&id=f81de274&scoped=true"
import script from "./ProductContentAssignments.vue?vue&type=script&lang=js"
export * from "./ProductContentAssignments.vue?vue&type=script&lang=js"
import style0 from "./ProductContentAssignments.vue?vue&type=style&index=0&id=f81de274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81de274",
  null
  
)

export default component.exports